import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sidebarIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-sicherheitshinweis" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sidebarIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-standortverwaltung" })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sidebarIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-benutzer" })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sidebarIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-dienstleisterverwaltung" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sidebarIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-einstellungen" })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_11 = { id: "personalSidebar" }
const _hoisted_12 = { class: "myAccount" }
const _hoisted_13 = {
  key: 0,
  href: "#",
  class: "sidebarText pl-3"
}

import Avatar from "@/components/system/Avatar.vue";
import { useSystemStore } from '@/stores/system/SystemStore';
import {ref, watch} from "vue";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

let openSidebar = ref(true);
const systemStore = useSystemStore();

const toggleSidebar = () => {
	openSidebar.value = !openSidebar.value
}

const rerenderTrigger = ref<number>(0);
watch(()=> systemStore.user?.roles, (/*newVal, oldVal*/)=>{
  // console.log("user changed", newVal, oldVal)
  rerenderTrigger.value++
})

const subIsActive = (input:any) => {
	const paths = Array.isArray(input) ? input : [input];
	const route = useRoute();
	return paths.some(path => {
		return route.path.indexOf(path) === 0 // current path starts with this path string
	})
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", {
    id: "sidebar",
    class: _normalizeClass(["", { openSidebar: _unref(openSidebar) }]),
    key: rerenderTrigger.value
  }, [
    _createElementVNode("div", {
      id: "toggleSidebar",
      class: _normalizeClass(_unref(openSidebar) ? 'rightArrow' : 'centeredArrow'),
      onClick: toggleSidebar
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_unref(openSidebar) ? 'icon-pfeil-links' : 'icon-pfeil-rechts')
      }, null, 2)
    ], 2),
    _createElementVNode("ul", null, [
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/forms/reports')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/forms/reports",
          id: "formReports"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("sidebar.FormReports")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Forms.View']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/plants')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/plants",
          id: "plants"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("sidebar.PlantManagment")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Plants.View']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/users')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/users",
          id: "users"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("sidebar.Users")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Users.View']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/providers')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/providers",
          id: "providers"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("sidebar.ProviderManagment")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Providers.View']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/settings')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/settings",
          id: "settings"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("sidebar.Settings")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Settings.View']
      ])
    ]),
    _createElementVNode("ul", _hoisted_11, [
      _createElementVNode("li", _hoisted_12, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/account",
          id: "account"
        }, {
          default: _withCtx(() => [
            _createVNode(Avatar),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("a", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_unref(systemStore).user?.firstName ?? "") + " " + _toDisplayString(_unref(systemStore).user?.lastName ?? ""), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})